import { z } from 'zod';
/**
 * AgentChangelogEntry — one row in the "what the agent learned this week"
 * changelog (issue #166 PR A). Each entry tags whether the change came
 * from a user correction (the CEO told the agent it was wrong) or from
 * a platform update (a new connector / model bump / new heuristic).
 * Tags categorize the kind of improvement so the changelog page can
 * filter and chip-render entries.
 *
 * Persisted at `organizations/{orgId}/agentChangelog/{id}`; surfaced by
 * `GET /api/orgs/:o/agent/changelog`. Append-only — the agent writes,
 * the user reads. Rules deny client writes.
 */
/** Categorical tag — drives the chip styling + filter affordance. */
export const AgentChangelogTag = z.enum([
    'speed',
    'accuracy',
    'new',
    'transparency',
    'respect',
    'identity',
    'honesty',
]);
/**
 * Source bucket — distinguishes user-driven changes (the CEO's
 * correction shaped the agent) from platform-driven changes (a model
 * upgrade, new connector, new heuristic).
 */
export const AgentChangelogSource = z.enum(['correction', 'platform']);
export const AgentChangelogEntry = z.object({
    id: z.string(),
    orgId: z.string(),
    /** When the change took effect. */
    date: z.string().datetime(),
    /** Headline — Fraunces h3 in the changelog row. */
    title: z.string(),
    /** Muted body — what changed + (if 'correction') why. */
    body: z.string(),
    tag: AgentChangelogTag,
    source: AgentChangelogSource,
});
